import { getOneClickIsSelectedOrderFromTable } from './../../selectors/one-click-orders.selector';
import { createSelector } from '@ngrx/store';
import { getOneClickOrders } from '@ordersnproducts/modules/one-click-order/selectors/one-click-orders.selector';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { BaseAsyncValue } from '../../../shared/models/async-value';

const oneClickOrdersAndTable = createSelector(
  getOneClickOrders,
  getOneClickIsSelectedOrderFromTable,
  (orders, { isFromTable }) => ({ orders, isFromTable }),
);

export namespace OneClickMultipleOption {
  export class IsMultipleOption extends BaseAsyncValue<Boolean> {
    getValue(): Observable<Boolean> {
      return this.store.select(getOneClickOrders).pipe(map(orders => orders.length > 1));
    }
  }

  export class IsSingleOption extends BaseAsyncValue<Boolean> {
    getValue(): Observable<Boolean> {
      return this.store
        .select(oneClickOrdersAndTable)
        .pipe(map(({ orders, isFromTable }) => (orders && orders.length <= 1) || isFromTable));
    }
  }
}
